import Map, { Marker, type ViewStateChangeEvent } from 'react-map-gl'
import { OSLO_LOCATION } from '@/lib/constants'
import { Location, Viewport } from '@/types/maps'

export const PickupLocationMap = ({
  viewport,
  setViewport,
  location,
}: {
  viewport: Viewport
  setViewport: (viewport: Viewport) => void
  location: Location
}) => {
  const accessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN
  const shouldShowMarker =
    location.latitude !== OSLO_LOCATION.latitude && location.longitude !== OSLO_LOCATION.longitude

  const onMove = (event: ViewStateChangeEvent) => {
    setViewport({
      latitude: event.viewState.latitude,
      longitude: event.viewState.longitude,
      zoom: event.viewState.zoom,
    })
  }

  return (
    <Map
      {...viewport}
      cooperativeGestures
      mapboxAccessToken={accessToken}
      mapStyle="mapbox://styles/mapbox/standard"
      onMove={onMove}
    >
      {shouldShowMarker && (
        <Marker latitude={location.latitude} longitude={location.longitude}>
          <i className="flex size-[18px] rounded-full border-2 border-black bg-isekk" />
        </Marker>
      )}
    </Map>
  )
}
